export default __webpack_public_path__ + "static/media/play-button.15ae1d4f.svg";